import React, { useState, useEffect } from 'react';
import {lang} from '../lang';

const FilterComponent = (props) => {
	const {styles,onFilter} = props;
    const [all_province, setAllProvince] = useState([]);
    const [all_district, setAllDistrict] = useState([]);
    const [hidden_district, setHiddleDistrict] = useState(true);
    const [district, setDistrict] = useState('');
    const [province, setProvince] = useState('');

	useEffect(() => {
		fetchInit();
	},[]);

    const fetchInit = async () =>{
        try {
            await fetch(
                "https://services.library.cmu.ac.th/api/api_province_with_amphure_tambon.json"
                )
                .then((response) => response.json())
                .then((result) => {
                    let provinces = result.sort(compareProvinces);
					let pfilter = provinces.filter(
						item => (parseInt(item.id)===50 || parseInt(item.id)===58));
                    setAllProvince(pfilter);
					let districts = [];
					let filter = pfilter.filter(
						item => (parseInt(item.id)===parseInt(result.province)),
					);
					if(filter[0]){
						setAllDistrict(filter[0].amphure.sort(compareProvinces));
					}
					setHiddleDistrict(false);
                });
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    const handleChangeProvince = (e) => {
        e.preventDefault();
		if(e.target.value===''){
			setAllDistrict('');
			setDistrict('');
			setProvince('');
			setHiddleDistrict(true);
		}else{
			setProvince(e.target.value);
			let filter = all_province.filter(
				item => (parseInt(item.id)===parseInt(e.target.value)),
			);
			// console.log(filter);

			setAllDistrict(filter[0].amphure.sort(compareProvinces));
			setDistrict('');
			setHiddleDistrict(false);

		}
    }


    function compareProvinces(a, b) {
        return a.name_th.localeCompare(b.name_th, 'th');
    }

    return (
    <>
		<fieldset className={styles["datatable-filter"]}>
			<div className={styles["input-group"]}>
				<label>{lang('ค้นหาแหล่งท่องเที่ยว','Attraction Search')}</label>
				<select name="province" id="province" value={province} onChange={e=>handleChangeProvince(e)} >
					<option value={""}>-- กรุณาเลือกจังหวัด --</option>
					{
						all_province.map((item, index)=>(
							(item!=='')?
							<option key={'y'+index} value={item.id}>{lang(item.name_th,item.name_en)}</option>
							:''
						))
					}
				</select>
				{(hidden_district===false)?
				<select name="district" id="district" value={district} onChange={e=>setDistrict(e.target.value)} >
					<option value={""}>-- กรุณาเลือกอำเภอ/เขต --</option>
					{
						all_district.map((item, index)=>(
							(item!=='')?
							<option key={'d'+index} value={item.id}>{lang(item.name_th,item.name_en)}</option>
							:''
						))
					}
				</select>
				:""}
				<input 
					type="text" 
					id="search" 
					placeholder={lang('ระบุคำค้น','Enter Keyword')}
					value={props.filterText} 
					onChange={e=>props.setFilterText(e.target.value)} 
					aria-label="Search Input" 
					aria-describedby="datatable-search" />
				<input type="button" className={styles["btn"]} value={lang('ค้นหา','Search')} onClick={e=>onFilter(props.filterText,province,district)}></input>
			</div>
		</fieldset>
		<small className="w-100 pb-2">{props.info}</small>
	</>
    )
};

export default FilterComponent;